import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['toggle', 'toggleable', 'markedForDeletion']
  static values = {
    open: { type: Boolean, default: false }
  }

  declare readonly toggleTarget: HTMLInputElement
  declare readonly toggleableTargets: HTMLInputElement[]
  declare readonly markedForDeletionTargets: HTMLInputElement[]
  declare openValue: boolean

  toggle (): void {
    this.openValue = !this.openValue
    this.toggleableTargets.forEach(toggleable => (toggleable.disabled = !this.openValue))

    if (!this.openValue) {
      this.markedForDeletionTargets.forEach(markedForDeletion => {
        markedForDeletion.value = 'true'
      })
    } else {
      this.markedForDeletionTargets.forEach(markedForDeletion => {
        markedForDeletion.value = 'false'
      })
    }
  }

  toggleOnlyDisabled (): void {
    const disabled = this.toggleableTargets.filter(toggleable => toggleable.disabled)
    const enabled = this.toggleableTargets.filter(toggleable => !toggleable.disabled)

    enabled.forEach(toggleable => (toggleable.disabled = true))
    disabled.forEach((toggleable: any) => {
      toggleable.disabled = false

      if (toggleable.tomselect !== undefined) {
        toggleable.tomselect.enable()
      }
    })
  }

  toggleDisabledByCondition ({ params: { disablingCondition } }: { params: { disablingCondition: string } }): void {
    this.openValue = this.toggleTarget.value === disablingCondition
    this.toggleableTargets.forEach(toggleable => (toggleable.disabled = !this.openValue))
  }
}
